import { render, staticRenderFns } from "./manual.vue?vue&type=template&id=0c11f798&scoped=true&"
import script from "./manual.vue?vue&type=script&lang=tsx&"
export * from "./manual.vue?vue&type=script&lang=tsx&"
import style0 from "./manual.vue?vue&type=style&index=0&id=0c11f798&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c11f798",
  null
  
)

export default component.exports